import Flex from './Flex';
import FlexItem from './FlexItem';
Flex.Item = FlexItem;
export default Flex;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/flex/index.js
// module id = 37
// module chunks = 0